module.exports = __webpack_public_path__ + "img/rain_light.26a314de.svg";